import { useLayoutEffect } from 'react';

export const useTextAreaAdjust = (MIN_TEXTAREA_HEIGHT = 32, textareaRef, value) => {
  useLayoutEffect(() => {
    // Reset height - important to shrink on delete
    textareaRef.current.style.height = 'inherit';
    textareaRef.current.style.height = `${Math.max(textareaRef.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
  }, [value, MIN_TEXTAREA_HEIGHT, textareaRef]);
};
